(ns common.schema.entities.survey.survey-auth-type
  "How a respondent proves who they are when they open a survey link.

   Kept beside the field rather than inline so the survey profile's default
   and the process's own value offer exactly the same choices.")

(def options
  [{:key   :auth-type/link
    :ord   0.0
    :label "Link only"}
   {:key   :auth-type/email
    :ord   1.0
    :label "Email authentication"}
   {:key   :auth-type/sms
    :ord   2.0
    :label "SMS authentication"}
   {:key   :auth-type/email-or-sms
    :ord   3.0
    :label "Email or SMS authentication"}])

(def by-key
  (->> options
       (map (juxt :key identity))
       (into {})))

(defn label
  [auth-type]
  (:label (get by-key auth-type)))
